import { render } from "./mshelYola.vue?vue&type=template&id=32dfec4d&scoped=true"
import script from "./mshelYola.vue?vue&type=script&lang=js"
export * from "./mshelYola.vue?vue&type=script&lang=js"

import "./mshelYola.vue?vue&type=style&index=0&id=32dfec4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32dfec4d"]])

export default __exports__